import excelJS from 'exceljs'
import { save } from 'save-file'
import moment from 'moment-timezone'

const columns = [
  { name: "Timestamp", item: "timestamp", width: 50, format: "date" },
  { name: "Action", item: "action", width: 50 },
  { name: "Stamps Collected", item: "stamps", width: 50 },
  { name: "Cards Redeemed", item: "cards", width: 50 },
  { name: "Reference", item: "reference", width: 50 },
  { name: "Adjusted by admin", item: "admin", width: 50 },
  { name: "Handled By", item: "username", width: 50 },
  { name: "Note", item: "note", width: 50 },
  { name: "Scan Location", item: "position", width: 50, format: "location" },
]

const giftCardHistory = async ({ fileName, data }) => {

  const workbook = new excelJS.Workbook()

  workbook.views = [
    {
      x: 0, y: 0, width: 3, height: 1000,
      firstSheet: 0, activeTab: 1, visibility: 'visible'
    }
  ]

  const font = { name: 'Courier', size: 12, bold: true }

  const passes_worksheet = workbook.addWorksheet("scans")

  columns.map((col, idx) => passes_worksheet.getColumn(idx + 1).width = col.width)

  const passes_row = passes_worksheet.getRow(1)

  columns.map((col, idx) => passes_row.getCell(idx + 1).value = col.name)

  columns.map((col, idx) => passes_row.getCell(idx + 1).font = font)

  data.map((r, i) => {
    const row = passes_worksheet.getRow(i + 2)

    columns.map((col, idx) => row.getCell(idx + 1).value = col.format ? formatDataItem(r, col) : r[col.item])
    columns.map((col, idx) => row.getCell(idx + 1).font = font)
  })


  const buffer = await workbook.xlsx.writeBuffer()

  await save(buffer, fileName + '.xlsx')
}

export default giftCardHistory

const formatDataItem = (row, col) => {

  const value = row[col.item]

  switch (col.format) {
    case "date": return value ? moment(value, "YYYYMMDDHHmmSS").format("YYYY-MM-DD HH:mm") : ""
    case "yes": return value === 1 ? "yes" : ""
    case "location": return value ? `${value.x},${value.y}` : ""
  }
}